import { useMemo as A, useCallback as m } from "react";
import { useAtomValue as C, useSetAtom as u } from "jotai";
import I from "./index152.mjs";
import { setCurrentStepAtom as E } from "./index25.mjs";
import { cartItemsAtom as F, giftCardsAtom as B, removeItemFromCartItemsAtom as G, removeGiftCardFromCartAtom as M, roomsAvailabilityAtom as P, setSummaryButtonAtom as V } from "./index34.mjs";
import { track as w } from "./index9.mjs";
import { TRACK_EVENT_TYPE as O, TRACK_EVENT as N } from "./index10.mjs";
import { useHotelConfig as z } from "./index93.mjs";
import { getSubscriptionPlanRoot as D } from "./index14.mjs";
import { useAlert as K } from "./index119.mjs";
const X = () => {
  const t = K(), i = C(F), g = C(B), a = u(G), s = u(M), _ = C(P), e = u(E), n = u(V), c = A(
    () => i.length === 1,
    [i.length]
  ), l = A(
    () => g.length === 1,
    [g.length]
  ), { hotelId: d, propertySize: b, propertyType: v, subscriptionPlan: y } = z(), f = m(
    (o) => {
      w(N.REMOVE_FROM_CART, O.REMOVED_FROM_CART, {
        hotel_id: d,
        property_type: v,
        property_size: b,
        subscription_plan: D(y),
        ecommerce: {
          currency: _.currency,
          value: parseFloat(o.totalPrice),
          items: [
            {
              item_id: o.id,
              item_name: o.roomName,
              item_type: "room",
              price: parseFloat(o.totalPrice),
              currency: _.currency,
              quantity: 1
            }
          ]
        }
      });
    },
    [
      d,
      v,
      b,
      y,
      _.currency
    ]
  ), k = m(
    (o) => {
      const r = i.find((T) => T.id === o), p = {
        label: I18n.t("booking_engine.information.confirm"),
        onClick: () => {
          r && f(r), a(o), c && e(1), n({
            disabled: !1
          }), t(null);
        }
      };
      t({
        icon: I,
        title: I18n.t("booking_engine.information.confirm_remove_room"),
        subTitle: I18n.t("booking_engine.information.warning_remove_room"),
        isShowCloseButton: !0,
        actions: [
          {
            label: I18n.t("booking_engine.information.cancel"),
            secondary: !0,
            onClick: () => {
              t(null);
            }
          },
          p
        ]
      });
    },
    [
      i,
      c,
      a,
      t,
      e,
      n,
      f
    ]
  ), R = m(
    (o) => {
      const r = i.find((p) => p.id === o);
      r && f(r), a(o), c && e(1), n({
        disabled: !1
      });
    },
    [
      i,
      c,
      a,
      e,
      n,
      f
    ]
  ), h = m(
    (o) => {
      const r = {
        label: I18n.t("booking_engine.information.confirm"),
        onClick: () => {
          s(o), l && e(1), n({
            disabled: !1
          }), t(null);
        }
      };
      t({
        icon: I,
        title: I18n.t("booking_engine.information.confirm_remove_gift_card"),
        subTitle: I18n.t("booking_engine.information.warning_remove_gift_card"),
        isShowCloseButton: !0,
        actions: [
          {
            label: I18n.t("booking_engine.information.cancel"),
            secondary: !0,
            onClick: () => {
              t(null);
            }
          },
          r
        ]
      });
    },
    [
      s,
      t,
      l,
      e,
      n
    ]
  ), S = m(
    (o) => {
      s(o), l && e(1), n({
        disabled: !1
      });
    },
    [
      s,
      e,
      n,
      l
    ]
  );
  return {
    removeCartItem: k,
    removeCartItemWithoutConfirmation: R,
    removeGiftCard: h,
    removeGiftCardWithoutConfirmation: S
  };
};
export {
  X as useRemoveCart
};
